import styled from "styled-components";

export const TableLeaderboardStyled = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .table_header_row {
    display: grid;
    grid-template-columns: ${({ $gridColumns }) => $gridColumns};
    align-items: center;
    background: ${({ theme }) => theme.COLORS.BLUE_26};
    border-radius: 8px;
    padding: 8px 20px;
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .table_header_cell {
    padding: 0 6px;
  }

  .table_row_block {
    display: flex;
    flex-direction: column;
  }

  .table_body_row {
    display: grid;
    grid-template-columns: ${({ $gridColumns }) => $gridColumns};
    align-items: center;
    padding: 4px 20px;
    min-height: 60px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_23};

  
  }

  .table_row_block .table_body_row {
    border-bottom: none;
  }

  .table_row_block .table_body_row:not(.is_expanded_parent) {
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_5};
  }

  .table_row_block .table_body_row.is_expanded_parent {
    border-bottom: none;
  }

  .expand_trigger {
    display: inline-flex;
    align-items: center;
    gap: 6px;
     text-decoration: underline;
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    cursor: pointer;
    user-select: none;
    padding: 0 6px;
    justify-self: end;
  }

  .expanded_section {
    padding: 0 24px 16px;
  }

  .expanded_label {
    background: ${({ theme }) => theme.COLORS.BLUE_26};
    padding: 12px 16px;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .sub_rows_container {
    border-left: 1px solid ${({ theme }) => theme.COLORS.GRAY_5};
    border-right: 1px solid ${({ theme }) => theme.COLORS.GRAY_5};
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_5};
  }

  .empty_state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }
`;
